import graphql__ca200a5ff9f55de508cf from "./__generated__/AnswerFormField_field.graphql.js";import { graphql, useFragment } from "react-relay";
import classNames from "classnames";

import AnswerPreview from "../AnswerPreview";

const AnswerFormField = props => {
  const { title, answer } = useFragment(AnswerFormField_field, props.field);
  if (!answer) return null;

  const className = classNames([
    "card",
    "bg-white",
    "margin-y-sm",
    "answer-form-field",
    props.className
  ]);

  return (
    <div className={className}>
      <div className="card-header text-legend padding-sm bg-gray-light">{title}</div>

      <div className="card-body padding-sm d-flex border-radius-bottom">
        <AnswerPreview answer={answer} />
      </div>
    </div>
  );
};

const AnswerFormField_field = graphql__ca200a5ff9f55de508cf;

export default AnswerFormField;
